import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12 4.5c.781 0 1.51.387 1.956 1.032l.085.133 6.64 11.216a2.434 2.434 0 0 1-.76 3.225 2.37 2.37 0 0 1-1.128.387l-.16.007H5.358a2.36 2.36 0 0 1-1.149-.313c-.35-.201-.645-.489-.856-.836a2.43 2.43 0 0 1-.108-2.328l.08-.153L9.963 5.662c.212-.355.511-.648.868-.852s.76-.31 1.17-.31m.008 11.036-.104.006a.82.82 0 0 0-.515.272.833.833 0 0 0 0 1.1.82.82 0 0 0 .515.272l.096.006.104-.006a.82.82 0 0 0 .515-.272.833.833 0 0 0 0-1.1.82.82 0 0 0-.515-.272zM12 9.74c-.2 0-.394.074-.544.209a.83.83 0 0 0-.269.522l-.005.097v3.311l.005.097c.024.201.12.387.27.521a.81.81 0 0 0 1.086 0 .83.83 0 0 0 .27-.521l.005-.097v-3.312l-.006-.096a.83.83 0 0 0-.268-.522.8.8 0 0 0-.544-.21"
    }, null, -1)
  ]))]))
}
export default { render: render }